import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Divider, Label, Icon, Button } from 'semantic-ui-react';

const labelStyle = {
  marginTop: 10,
  marginBottom: 10,
};

const ConnectedAccount = ({
  name,
  id,
}) => (
  <div>
    <p>{name} is linked to this Ads Manager account.</p>
    <Divider hidden fitted />
    <Label size="large" style={labelStyle}>
      <Icon name="facebook" color="blue" />{_.upperCase(id)}
      <Label.Detail>
        <Icon name="check circle" color="green" />
      </Label.Detail>
    </Label>
    <Divider />
    <Button disabled inverted fluid icon labelPosition="left" color="red">
      <Icon name="unlinkify" />
        Unlink my account
    </Button>
  </div>
);

ConnectedAccount.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default ConnectedAccount;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-connected-account/index.js
 **/